module.exports = __webpack_public_path__ + "static/LOGO_G-01d301e8f25c86d2c23a64ee5a29aa3b.svg";